import * as React from "react"
import { batch } from "@preact/signals-react"

import { CommonFilters } from "@components"
import { isLoadingCommonFilters } from "@signals"


export default function AdminSkuFilters() {

    return <CommonFilters
        components={{
            category: true, brand: true,
            validated: true
        }}
        compProps={{
            category: { grid: { md: 5 }, placement: 'bottomStart' },
            brand: { grid: { md: 5 } },
            validated: { grid: { md: 2 } }
        }}
        onSubmit={() => { batch(() => {
            isLoadingCommonFilters.value = true
        })}}
    />
}